import { useEffect, useRef } from 'react';
import { useNavigate, useOutletContext, useSearchParams } from 'react-router';

import { LoadingPlaceholder } from '~/components/premarketplace/loading-placeholder';
import { usePartnerStepConfiguration } from '~/components/premarketplace/partner-config';
import { OutletContextType } from '~/types/marketplace';

export default function PremarketplaceIndex() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { partner } = useOutletContext<OutletContextType>();
  const hasNavigatedRef = useRef(false);

  const partnerStepConfiguration = usePartnerStepConfiguration(partner);
  const firstStep = partnerStepConfiguration?.steps?.[0];

  useEffect(() => {
    if (!hasNavigatedRef.current && firstStep) {
      hasNavigatedRef.current = true;

      // Preserve existing search parameters while navigating to the first step
      const currentSearchParams = new URLSearchParams(searchParams);
      const searchString = currentSearchParams.toString();
      const url = `/premarketplace/${firstStep.id}${searchString ? `?${searchString}` : ''}`;

      navigate(url, { replace: true });
    }
  }, [firstStep, navigate, searchParams]);

  // This component renders nothing as it immediately redirects
  return <LoadingPlaceholder />;
}
